import { keepPreviousData, useQuery } from "@tanstack/react-query";
import * as Immutable from "immutable";
import { StreamDestinationsFilters } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
export const KEY_PREFIX = ["streams", "output", "filters"];
export const keyFn = (streamId, destinationType, pagination) => [
  ...KEY_PREFIX,
  streamId,
  destinationType != null ? destinationType : "all",
  pagination
];
const defaultParams = { page: 1, perPage: 10, query: "" };
export const fetchStreamOutputFilters = async (streamId, pagination) => StreamDestinationsFilters.getPaginatedFiltersForStream(
  streamId,
  pagination.query || void 0,
  pagination.page,
  pagination.perPage
).then((response) => {
  const { elements, query, total, page, per_page: perPage, count } = response;
  return {
    list: Immutable.List(elements),
    attributes: [],
    pagination: {
      total,
      page,
      perPage,
      query,
      count
    }
  };
});
const useStreamOutputFilters = (streamId, destinationType, pagination = defaultParams) => {
  const { data, refetch, isLoading, isSuccess } = useQuery({
    queryKey: keyFn(streamId, destinationType, pagination),
    queryFn: () => defaultOnError(
      fetchStreamOutputFilters(streamId, {
        ...pagination,
        query: destinationType ? `destination_type:${destinationType}` : pagination.query
      }),
      "Loading stream output filters failed with status",
      "Could not load stream output filters"
    ),
    placeholderData: keepPreviousData
  });
  return {
    data,
    refetch,
    isLoading,
    isSuccess
  };
};
export default useStreamOutputFilters;
